<template>
    <article class="amLibrary">
        <h3 class="amLibrary__title">
            Library
        </h3>

        <ul class="amLibrary__list">
            <li
                v-for="animation in sortedAnimations"
                :key="animation.id"
                class="amLibrary__item"
                @click="onLoadAnimation(animation.id)"
            >
                <span>{{ animation.label || 'Untitled Animation' }}</span>

                <button class="amLibrary__delete" type="button" @click.stop="onDelete(animation.id)">
                    <font-awesome-icon :icon="['fal', 'times']" />
                </button>
            </li>

            <li v-if="!sortedAnimations.length" class="amLibrary__empty">
                No animations found.
            </li>
        </ul>

        <footer class="amLibrary__footer">
            <button class="amLibrary__button" type="button" @click="$emit('add')">
                ADD NEW
            </button>
        </footer>
    </article>
</template>

<script>
export default {
    name: 'animation-library',

    props: {
        animations: {
            type: Array,
            required: true,
        },
    },

    computed: {
        sortedAnimations() {
            return [...this.animations].sort((a1, a2) => {
                return a1.label.toLowerCase() < a2.label.toLowerCase() ? -1 : 1;
            });
        },
    },

    methods: {
        onLoadAnimation(id) {
            this.$emit('select', id);
        },

        onDelete(id) {
            this.$emit('delete', id);
        },
    },
};
</script>

<style lang="scss" scoped>
.amLibrary {
    &__title {
        display: inline-block;
        font-size: 0.875rem;
        font-weight: 600;
        padding: 0.5em 1.25em;
        background-color: var(--app-borderColor);
    }

    &__list {
        border: 2px solid var(--app-borderColor);
    }

    &__item {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.5em 0.75em;

        &:not(:first-of-type) {
            border-top: 1px solid var(--app-borderColor);
        }

        &:hover {
            cursor: pointer;
            background-color: var(--app-hoverBackgroundColor);
        }
    }

    &__delete {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 0.5em;
        font-size: 1.25rem;
        color: var(--app-linkColor);

        &:hover {
            color: var(--app-linkHoverColor);
        }
    }

    &__footer {
        margin-top: 5rem;
    }

    &__button {
        @extend %button;
        font-weight: 600;
    }

    &__empty {
        padding: 1em;
        color: var(--app-color);
        background-color: var(--app-hoverBackgroundColor);
        border: 1px solid var(--form-inputBorderColor);
    }
}
</style>
